import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

if (filterListStyles.wrapper) {
    filterListStyles.wrapper.css = css`
        padding: 15px 18px 0px 18px;
        border: 1px solid #e1e1e1;
        border-bottom: 4px solid #bdbcbc;
        border-top: none;
        text-transform: uppercase;
        background-color: #f8f8f8;
        & h3 {
            font-size: 15px;
            display: none;
        }
    `;
}

if (columnsStyles.leftColumnGridItem && columnsStyles.rightColumnGridItem) {
    columnsStyles.rightColumnGridItem.css = css`
        padding-left: 30px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-left: 0px;
                    padding-top: 20px;
                `,
                css`
                    padding-left: 0px;
                    padding-top: 20px;
                `,
                null,
                null,
                null,
            ])}
    `;

    columnsStyles.container = {
        gap: 0,
    };
}
if (filtersAccordionStyles.accordion) {
    filtersAccordionStyles.accordion.css = css`
        & dl {
            flex-basis: 100%;
        }
        & dt {
            height: 62px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        height: 55px;
                    `,
                    null,
                    null,
                ])}
            button {
                background-color: #fff;
                padding: 18px;
                border: 1px solid #cccccc;
                &:focus {
                    padding: 18px !important;
                    border: 1px solid #cccccc;
                }
                & span {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                font-size: 11px;
                            `,
                            null,
                            null,
                        ])}
                }
                svg {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                display: block;
                            `,
                            css`
                                display: block;
                            `,
                            css`
                                display: block;
                            `,
                        ])}
                }
            }
        }
        & dd {
            background-color: #f8f8f8;
            padding: 18px;
            border: 1px solid #e1e1e1;
            span[role="checkbox"] {
                background-color: #fff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            margin-top: 0px;
                        `,
                        null,
                        null,
                    ])}
            }

            & label {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            font-size: 11px;
                        `,
                        null,
                        null,
                    ])}
            }
        }
    `;
}

searchWithinStyles.wrapper = {
    css: css`
        padding: 18px;
        background-color: #f8f8f8;
        border: 1px solid #e1e1e1;
        & div input[type="text"] {
            border: 1px solid #bdbcbc;
            border-radius: 17px;
            background: transparent;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        font-size: 11px;
                    `,
                    null,
                    null,
                ])}
        }
    `,
};

filterListStyles.filterTag = {
    color: "primary",
    typographyProps: {
        css: css`
            font-weight: 500;
        `,
    },
};
